import React, { useEffect, useState } from 'react';
import { MiniNavigation } from '../../../ui-toolkit';
import { IPropertyAddress, propertyAddressToString } from '../../../ui-toolkit/orders/interfaces/IPropertyAddress';
import { bullet } from '../../../utilities/order/magicStrings';

interface IClientPageHeaderMiniNavigationProps {
  activeSub?: string;
  navigationItems?: JSX.Element[];
  property: IPropertyAddress;
  showSub?: boolean;
  names: string;
  fileNumber: string | null;
}

export const ClientPageHeaderMiniNavigation: React.FC<IClientPageHeaderMiniNavigationProps> = ({
  activeSub,
  property,
  showSub,
  navigationItems,
  names,
  fileNumber,
}) => {
  const [miniNavigationShowsWhen, setWhenMiniNavigationShows] = useState(0);
  const reference = React.createRef<HTMLDivElement>();
  const addressSummary = propertyAddressToString(property);
  useEffect(() => {
    if (reference.current) {
      setWhenMiniNavigationShows(reference.current.offsetTop + reference.current.offsetHeight / 2);
    }
  }, [setWhenMiniNavigationShows, reference]);

  return (
    <MiniNavigation
      when={miniNavigationShowsWhen}
      active={activeSub}
      primary={`${addressSummary}${property.countyName ? ` ${bullet} ${property.countyName}` : ``}`}
      secondary={`${names} ${bullet} ${fileNumber}`}
    >
      {showSub ? navigationItems : undefined}
    </MiniNavigation>
  );
};
